import { Box, Icon, Typography } from "@mui/material";
import { green, orange, red } from "@mui/material/colors";
import { grey, alphaVar } from "../../../../../theme/muiColors";
import { CheckCircleOutlineOutlined, CloseOutlined, WarningAmberOutlined } from "@mui/icons-material";

export const PaymentsReceivableField = ({ value }: { value: boolean }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 1.5,
        border: `1px solid ${alphaVar(grey[400], 0.4)}`,
        borderRadius: 1,
        p: 1,
        mt: 2,
        mb: 2,
      }}
    >
      <Icon
        sx={{
          flexShrink: 0,
          alignSelf: "center",
          backgroundColor: value ? alphaVar(green[500], 0.2) : alphaVar(red[500], 0.2),
          borderRadius: "50%",
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {value ? (
          <CheckCircleOutlineOutlined sx={{ fontSize: 20, color: green[500] }} />
        ) : (
          <WarningAmberOutlined sx={{ fontSize: 20, color: orange[500] }} />
        )}
      </Icon>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0, minWidth: 0 }}>
        <Typography variant="body1" sx={{ fontWeight: 500, color: grey[700] }}>
          Payments Receivable
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 400, color: grey[600] }}>
          {value
            ? "Your account is fully authorized to collect and process payments."
            : "Your account is not fully authorized to receive payments. Please check your PayPal account settings."}
        </Typography>
      </Box>
    </Box>
  );
};